import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.scss";
import UniversalNavBar from "./Components/Header/UniversalNavBar";
import Footer from "./Components/Footer/Footer";
import Home from "./pages/home/Home";
import Advisories from "./pages/advisories/Advisories";
import Report from "./pages/report/Report";
import Details from "./modules/advisories/detail_advisories/detail";
import Policy from "./pages/policy/Policy";
import Resources from "./pages/resources/resources";
import Bulletins from "./pages/bulletins/Bulletins";
import BulletinsDetailPage from "./pages/bulletins/detail/detail_bulletin";
import Certifications from "./pages/certifications/Certifications";
import NotFound from "./pages/notfound/NotFound";
import { cookieSettings } from "./utils/cookieSettings";

function App() {
  useEffect(() => {
    // Initialize reCAPTCHA
    const scriptId = "recaptcha-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        console.log("reCAPTCHA script loaded");
      };
      script.onerror = () => {
        console.error("Failed to load reCAPTCHA script");
      };
      document.head.appendChild(script);
    }

    // Initialize cookie settings
    cookieSettings.initialize();

    // Dynamically set header height CSS variable to remove gaps
    const setHeaderHeightVar = () => {
      const headerEl = document.querySelector(".universal-navbar .headerFrame");
      if (headerEl) {
        const h = headerEl.offsetHeight || 0;
        document.documentElement.style.setProperty("--headerH", `${h}px`);
      }
    };

    // Set on load and on resize
    setHeaderHeightVar();
    window.addEventListener("resize", setHeaderHeightVar);

    return () => {
      window.removeEventListener("resize", setHeaderHeightVar);
    };
  }, []);

  return (
    <Router>
      <div className="root-container">
        <UniversalNavBar />
        {/* Offset main content below the fixed header using a dynamic variable */}
        <main className="page-content-with-header">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/advisory" element={<Advisories />} />
            <Route path="/report" element={<Report />} />
            <Route path="/advisory/:adv_id" element={<Details />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/bulletins" element={<Bulletins />} />
            <Route path="/bulletins/:bulletinId" element={<BulletinsDetailPage />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;